import React from "react";
import AiUsageGranularityToggle from "./AiUsageGranularityToggle";
import {
  AI_USAGE_CARE_SECTOR_OPTIONS,
  AI_USAGE_DATE_PRESETS,
} from "./aiUsageOverview.utils";

const AiUsageFilterBar = ({
  filters,
  granularity,
  granularityOptions,
  onPresetChange,
  onCareSectorChange,
  onGranularityChange,
  showSector = true,
  disabled = false,
  idPrefix = "ai-usage",
}) => (
  <div className="mb-4 flex flex-wrap items-end gap-4">
    <div>
      <p className="mb-2 text-xs font-medium uppercase tracking-wide text-gray-500">Period</p>
      <div className="flex flex-wrap gap-2">
        {AI_USAGE_DATE_PRESETS.map((preset) => (
          <button
            key={preset.id}
            type="button"
            disabled={disabled}
            onClick={() => onPresetChange(preset.id)}
            className={`rounded-full px-3 py-1.5 text-xs font-medium disabled:opacity-50 ${
              filters.preset === preset.id && !filters.from
                ? "bg-indigo-600 text-white"
                : "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
            }`}
          >
            {preset.label}
          </button>
        ))}
      </div>
    </div>

    {showSector ? (
      <div>
        <label
          htmlFor={`${idPrefix}-care-sector`}
          className="mb-2 block text-xs font-medium uppercase tracking-wide text-gray-500"
        >
          Sector
        </label>
        <select
          id={`${idPrefix}-care-sector`}
          value={filters.careSector}
          disabled={disabled}
          onChange={onCareSectorChange}
          className="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 disabled:opacity-50"
        >
          {AI_USAGE_CARE_SECTOR_OPTIONS.map((option) => (
            <option key={option.value || "all"} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    ) : null}

    <div>
      <p className="mb-2 text-xs font-medium uppercase tracking-wide text-gray-500">Trend</p>
      <AiUsageGranularityToggle
        value={granularity}
        options={granularityOptions}
        onChange={onGranularityChange}
        disabled={disabled}
      />
    </div>
  </div>
);

export default AiUsageFilterBar;
